<script setup>
import {ref} from 'vue'

const props = defineProps({
    column: Object,
    value: String
})

const text = ref('')

// created logic executed during setup initialization
let options = props.column.options

// todo - I think the idea here was to replace the option's "value" property with its "text" property.
if (
    options // Fix for typeof null === object JavaScript bug. https://stackoverflow.com/questions/18808226/why-is-typeof-null-object
    && typeof options === 'object'
    && options[props.value]
) {
    text.value = options[props.value]
} else {
    text.value = props.value
}
</script>

<template>
    <span v-if="text" v-html="text"/>
</template>